<script>
	import {onMount} from 'svelte'
	import {createEventDispatcher} from 'svelte'
	import {CLIENTE} from '../store.js'

	const dispatch = createEventDispatcher()

	export let idcliente= 0
	let vista =  idcliente===0 ? 'pend' : 'cli' // de cliente | pendientes

	function set_cliente(){
		CLIENTE.set(5000)
	}

	function close(){
		dispatch('close')
	}

	onMount( () => {
		idcliente = $CLIENTE
	})
</script>

<div class="flotante-derecha border clearfix shadow rounded-sm">
	<span class="btn btn-sm float-end text-danger" on:click="{close}">&Cross;</span><br>
	<div class="container-fluid mt-2">
		
		<h3>Vista no disponible</h3>

	</div>
</div>
